import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-border bg-background mt-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <div className="font-display text-2xl">FinanceLocal</div>
          <p className="mt-3 text-sm text-muted-foreground">
            Institutional-grade marketplace for cash-flowing automobile notes.
          </p>
        </div>
        <div>
          <div className="font-overline mb-3">Marketplace</div>
          <ul className="space-y-2 text-sm text-muted-foreground" data-testid="footer-marketplace">
            <li><Link to="/notes" className="hover:text-primary transition-colors" data-testid="footer-notes">Available Notes</Link></li>
            <li><Link to="/originations" className="hover:text-primary transition-colors" data-testid="footer-originations">Originations</Link></li>
            <li><Link to="/applications" className="hover:text-primary transition-colors" data-testid="footer-applications">Pre-Approve a Buyer</Link></li>
            <li><Link to="/apply" className="hover:text-primary transition-colors" data-testid="footer-apply">Apply for Financing</Link></li>
            <li><Link to="/how-it-works" className="hover:text-primary transition-colors" data-testid="footer-how">How It Works</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-overline mb-3">Coming Soon</div>
          <ul className="space-y-2 text-sm text-muted-foreground" data-testid="footer-coming-soon">
            <li><Link to="/coming-soon#calculator" className="hover:text-primary transition-colors" data-testid="footer-calc">Yield Calculator</Link></li>
            <li><Link to="/coming-soon#valuation" className="hover:text-primary transition-colors" data-testid="footer-valuation">Note Valuation Engine</Link></li>
            <li><Link to="/coming-soon#watchlist" className="hover:text-primary transition-colors" data-testid="footer-watchlist">Watchlist Notifications</Link></li>
            <li><Link to="/coming-soon#dealer" className="hover:text-primary transition-colors" data-testid="footer-dealer">Dealer Accounts</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-overline mb-3">Legal</div>
          <ul className="space-y-2 text-sm text-muted-foreground" data-testid="footer-legal">
            <li><Link to="/legal" className="hover:text-primary transition-colors" data-testid="footer-legal-notice">Legal Notice</Link></li>
            <li><Link to="/legal#legal-terms" className="hover:text-primary transition-colors">Terms of Service</Link></li>
            <li><Link to="/legal#legal-privacy" className="hover:text-primary transition-colors">Privacy Policy</Link></li>
            <li><Link to="/legal#legal-disclosures" className="hover:text-primary transition-colors">Risk Disclosures</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border py-4 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} FinanceLocal. All rights reserved.
      </div>
    </footer>
  );
}
